import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  ACESSO_SISTEMA_LOGOUT_BEGIN,
  ACESSO_SISTEMA_LOGOUT_SUCCESS,
  ACESSO_SISTEMA_LOGOUT_FAILURE,
  ACESSO_SISTEMA_LOGOUT_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function logout(callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: ACESSO_SISTEMA_LOGOUT_BEGIN,
    callback,
  };
}

export function dismissLogoutError() {
  return {
    type: ACESSO_SISTEMA_LOGOUT_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on ACESSO_SISTEMA_LOGOUT_BEGIN actions
export function* doLogout(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.logoff();
  } catch (err) {
    yield put({
      type: ACESSO_SISTEMA_LOGOUT_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(ACESSO_SISTEMA_LOGOUT_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: ACESSO_SISTEMA_LOGOUT_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(ACESSO_SISTEMA_LOGOUT_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchLogout() {
  yield takeLatest(ACESSO_SISTEMA_LOGOUT_BEGIN, doLogout);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case ACESSO_SISTEMA_LOGOUT_BEGIN:
      return {
        ...state,
        logoutPending: true,
        logoutError: null,
      };

    case ACESSO_SISTEMA_LOGOUT_SUCCESS:
      return {
        ...state,
        usuario: {},
        accessTokens: {},
        logoutPending: false,
        logoutError: null,
      };

    case ACESSO_SISTEMA_LOGOUT_FAILURE:
      return {
        ...state,
        logoutPending: false,
        logoutError: action.data.error,
      };

    case ACESSO_SISTEMA_LOGOUT_DISMISS_ERROR:
      return {
        ...state,
        logoutError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/logout.js